// extracted by mini-css-extract-plugin
module.exports = {"button":"_3XRmf5","shine-lines":"_20oMu7"};